import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DownIcon, UpIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { INNER_CARD_BORDER_RADIUS } from '../../config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BorderedDiv = styled.div.withConfig({
  displayName: "ResponseFooter__BorderedDiv",
  componentId: "sc-1am51va-0"
})(["border-top:", ";border-radius:0 0 ", "px ", "px;background:", ";"], ({
  theme
}) => `${theme.borderWidth[100]} solid ${theme.color['fill-tertiary-pressed']}`, INNER_CARD_BORDER_RADIUS, INNER_CARD_BORDER_RADIUS, ({
  theme
}) => theme.color['fill-tertiary-default']);
const ResponseFooter = ({
  expanded,
  onClick
}) => {
  return /*#__PURE__*/_jsx(Clickable, {
    onClick: onClick,
    children: /*#__PURE__*/_jsx(BorderedDiv, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h5",
        typography: "heading-50",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          padding: "400",
          children: [expanded ? /*#__PURE__*/_jsx(UpIcon, {
            color: "fill-info-default"
          }) : /*#__PURE__*/_jsx(DownIcon, {
            color: "fill-info-default"
          }), expanded ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.response.response.showLess"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.response.response.showMore"
          })]
        })
      })
    })
  });
};
export default ResponseFooter;